import axios from './configAxios';

export const postContainerApi = async (terminal_id, requestData) => {
	console.log(terminal_id, 'RRRRRRRRRRRRRRR');
	console.log(requestData, 'POST CONTAINER');
	return axios.post(`/${terminal_id}/`, requestData);
};
